"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonPatientChats = void 0;
const IGroupChats_1 = require("./IGroupChats");
const models_1 = require("../../models");
const utils_1 = require("../../utils");
const roleAccess_1 = require("../../roleAccess/roleAccess");
const mappers_1 = require("../../mappers");
class NonPatientChats extends IGroupChats_1.IGroupChats {
    constructor(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage) {
        super(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this.chatGroup = {
            data: [],
            limit: utils_1.HHNConstants.GROUP_PAGINATION_LIMIT,
            page: 0,
            total: 0,
        };
        this.filteredChatGroup = {
            data: [],
            limit: utils_1.HHNConstants.GROUP_PAGINATION_LIMIT,
            page: 0,
            total: 0,
        };
    }
    init() {
        super.init();
        this.removeListeners.push(this.hideChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.unHideChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.addChatListener(() => {
            this.notifyChange();
        }));
    }
    getChatsStorage() {
        return this.hhnStorage.chatsStorage;
    }
    getGroupType() {
        return models_1.GROUP_TYPE.NON_PATIENT;
    }
    addChat(data) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-useless-catch
            try {
                if (!this.organizationUser.hasAccess(roleAccess_1.FEATURES.CREATE_INTERNAL_GROUP)) {
                    throw new Error(utils_1.ErrorMessages.noAccessFound);
                }
                const requestPayload = Object.assign(Object.assign({}, data), { type: models_1.GROUP_TYPE.NON_PATIENT });
                yield this.httpAdapter.getChatAdapter().addGroup(requestPayload);
            }
            catch (e) {
                throw e;
            }
        });
    }
    getFetchedChats() {
        return this.previousSearchText ? this.filteredChatGroup : this.chatGroup;
    }
    fetchChatGroup(searchText, isSearchClear, context) {
        return __awaiter(this, void 0, void 0, function* () {
            let pageNo;
            let isNewSearch = false;
            if (searchText && searchText !== this.previousSearchText) {
                pageNo = 1;
                isNewSearch = true;
                this.resetChatGroup();
            }
            else if (searchText && searchText === this.previousSearchText) {
                pageNo = this.filteredChatGroup.page + 1;
            }
            else {
                pageNo = isSearchClear ? 1 : this.chatGroup.page + 1;
            }
            this.previousSearchText = searchText;
            const nonPatientGroupsResult = yield this.httpAdapter
                .getChatAdapter()
                .getNonPatientGroups({
                limit: utils_1.HHNConstants.GROUP_PAGINATION_LIMIT,
                pageNo,
                search: searchText || undefined,
            }, context);
            if (!nonPatientGroupsResult.isAborted) {
                const chatGroups = (0, mappers_1.nonPatientChatGroupsMapper)(nonPatientGroupsResult.data);
                this.populateChatGroups(chatGroups, searchText, isSearchClear, isNewSearch);
            }
        });
    }
    populateChatGroups(response, search, isSearchClear, isNewSearch) {
        let newGroupList;
        if (search) {
            const existingSearchGroups = this.filteredChatGroup;
            newGroupList = Object.assign(Object.assign({}, existingSearchGroups), { limit: response.limit, data: isNewSearch
                    ? [...response.data]
                    : [...existingSearchGroups.data, ...response.data], total: response.total, page: existingSearchGroups.page + 1 });
        }
        else {
            const existingGroups = this.chatGroup;
            newGroupList =
                existingGroups && !isSearchClear
                    ? Object.assign(Object.assign({}, existingGroups), { data: [...existingGroups.data, ...response.data], limit: response.limit, total: response.total, page: existingGroups.page + 1 }) : {
                    data: response.data,
                    limit: response.limit,
                    total: response.total,
                    page: (existingGroups === null || existingGroups === void 0 ? void 0 : existingGroups.page) + 1 || 1,
                };
        }
        search
            ? (this.filteredChatGroup = newGroupList)
            : (this.chatGroup = newGroupList);
    }
    resetChatGroup() {
        this.chatGroup = {
            data: [],
            limit: utils_1.HHNConstants.GROUP_PAGINATION_LIMIT,
            page: 0,
            total: 0,
        };
        this.filteredChatGroup = {
            data: [],
            limit: utils_1.HHNConstants.GROUP_PAGINATION_LIMIT,
            page: 0,
            total: 0,
        };
    }
}
exports.NonPatientChats = NonPatientChats;
